export default "__VITE_ASSET__CKZ4e8Fh__"